import { batch } from "react-redux";

import {
  AutoProfileConstants,
  ConcentrateStateMapper,
} from "@/constants/autoProfileEnum";
import {
  FINAL_VOLUME,
  STARTING_VOLUME,
  STARTING_CONCENTRATION,
  FINAL_CONCENTRATION,
} from "@/constants/fieldNames";
import {
  calcEstFinalConcentrationConcentrate,
  calcFinalVolumeConcentrate,
  parseNumberParam,
} from "@/libs/autoProfileHelper";
import { objMapper } from "@/libs/objectHelper";

import {
  bulkUpdateProfileParamByName,
  removeInvalidAutoProfileParamByName,
} from "./autoProfileBusiness";

export const changeConcentrateParam = (type, value) => (dispatch) => {
  let params = {};

  switch (type) {
    case STARTING_VOLUME:
      params = dispatch(setStartingVol(value));
      break;
    case FINAL_VOLUME:
      params = dispatch(setFinalVol(value));
      break;
    case STARTING_CONCENTRATION:
      params = dispatch(setStartingConcVol(value));
      break;
    case FINAL_CONCENTRATION:
      params = dispatch(setEstFinalConcVol(value));
      break;

    default:
      break;
  }

  return objMapper(params, ConcentrateStateMapper);
};

export const setStartingVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const { FinalVolume, StartingConcentration, EstimatedFinalConcentration } =
    currentProfileParams;

  const startingVol = Number(value);
  let finalVol = parseNumberParam(FinalVolume);
  let startingConc = parseNumberParam(StartingConcentration);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [STARTING_VOLUME];
  let profileParam = {
    StartingVolume: startingVol,
  };

  if (!startingConc) {
    startingConc = AutoProfileConstants.DEFAULT_STARTING_CONC;
    removeInvalidParams.push(STARTING_CONCENTRATION);
    profileParam = {
      ...profileParam,
      StartingConcentration: startingConc,
    };
  }

  if (finalVol && estFinalConcentration && finalVol > startingVol) {
    finalVol = calcFinalVolumeConcentrate(
      startingVol,
      estFinalConcentration,
      startingConc
    );
    removeInvalidParams.push(FINAL_VOLUME);
    profileParam = {
      ...profileParam,
      FinalVolume: finalVol,
    };
  }

  if (finalVol && startingConc) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate(
      startingVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setFinalVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const { StartingVolume, StartingConcentration, EstimatedFinalConcentration } =
    currentProfileParams;

  const finalVol = Number(value);

  const startingVol = parseNumberParam(StartingVolume);
  const startingConc = parseNumberParam(StartingConcentration);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [FINAL_VOLUME];
  let profileParam = {
    FinalVolume: finalVol,
  };

  if (startingVol && startingConc) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate(
      startingVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setStartingConcVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const { StartingVolume, FinalVolume, EstimatedFinalConcentration } =
    currentProfileParams;

  const finalVol = parseNumberParam(FinalVolume);
  const startingVol = parseNumberParam(StartingVolume);
  const startingConc = Number(value);
  let estFinalConcentration = parseNumberParam(EstimatedFinalConcentration);

  const removeInvalidParams = [STARTING_CONCENTRATION];
  let profileParam = {
    StartingConcentration: startingConc,
  };

  if (startingVol && finalVol) {
    estFinalConcentration = calcEstFinalConcentrationConcentrate(
      startingVol,
      finalVol,
      startingConc
    );
    removeInvalidParams.push(FINAL_CONCENTRATION);
    profileParam = {
      ...profileParam,
      EstimatedFinalConcentration: estFinalConcentration,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};

export const setEstFinalConcVol = (value) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const { StartingVolume, FinalVolume, StartingConcentration } =
    currentProfileParams;

  let finalVol = parseNumberParam(FinalVolume);
  const startingVol = parseNumberParam(StartingVolume);
  const startingConc = parseNumberParam(StartingConcentration);
  const estFinalConcentration = Number(value);

  const removeInvalidParams = [FINAL_CONCENTRATION];
  let profileParam = {
    EstimatedFinalConcentration: estFinalConcentration,
  };

  if (startingVol && startingConc) {
    finalVol = calcFinalVolumeConcentrate(
      startingVol,
      estFinalConcentration,
      startingConc
    );
    removeInvalidParams.push(FINAL_VOLUME);
    profileParam = {
      ...profileParam,
      FinalVolume: finalVol,
    };
  }

  batch(() => {
    dispatch(removeInvalidAutoProfileParamByName(removeInvalidParams));
    dispatch(bulkUpdateProfileParamByName(profileParam));
  });

  return profileParam;
};
